import classNames from 'classnames';

const LiveKitPrimaryButton = ({ children, className, disabled, loading, onClick }) => (
	<button
		className={classNames('lk-primary-btn', { 'lk-primary-btn--loading': loading }, className)}
		disabled={disabled || loading}
		type="button"
		onClick={onClick}
	>
		{loading
			? <span aria-label="Carregando" className="lk-primary-btn__spinner" role="status" />
			: children}
	</button>
);

export default LiveKitPrimaryButton;
